export const getOrdersStart = () => ({
	type: "GET_ORDERS_START",
});

export const getOrdersSuccess = (orders) => ({
	type: "GET_ORDERS_SUCCESS",
	payload: orders
});

export const getOrdersFailure = () => ({
	type: "GET_ORDERS_FAILURE",
});

export const getOrderStart = () => ({
	type: "GET_ORDER_START",
});

export const getOrderSuccess = (order) => ({
	type: "GET_ORDER_SUCCESS",
	payload: order
});

export const getOrderFailure = () => ({
	type: "GET_ORDER_FAILURE",
});